// ImageDialog "Saved" images in the order they were taken (user, 2026-10-25).
// An image's date is its EXIF date (exif_data.date) when it has one, else the
// date it was stored with (the photo's own date when picked from the library,
// else the upload time). Dated images come first, oldest first; images without
// a usable date follow, by name. Returns a new array; the input is not changed.
// Same file in andiamo-places/src/Common.

const toTime = (value) => {
  if (value === null || typeof value === "undefined" || value === "") return null;
  const t = typeof value === "number" ? value : Date.parse(value);
  return Number.isFinite(t) ? t : null;
};

export function imageTime(image) {
  if (!image) return null;
  const exifDate = image.exif_data ? toTime(image.exif_data.date) : null;
  return exifDate !== null ? exifDate : toTime(image.date);
}

const byName = (a, b) => String(a.name || "").localeCompare(String(b.name || ""), undefined, { sensitivity: "base", numeric: true });

export function sortImagesByDate(images) {
  return (images || [])
    .map((image, index) => ({ image, index, time: imageTime(image) }))
    .sort((a, b) => {
      if (a.time !== null && b.time !== null) return a.time - b.time || byName(a.image, b.image) || a.index - b.index;
      if (a.time !== null) return -1;
      if (b.time !== null) return 1;
      return byName(a.image, b.image) || a.index - b.index;
    })
    .map((x) => x.image);
}
